import React, {useEffect, useState} from 'react'
import DatePicker from 'react-datepicker'
import ColorPicker, {useColorPicker} from 'react-best-gradient-color-picker'
import {Calendar, momentLocalizer} from 'react-big-calendar-scheduler'
import axios from 'axios'
import moment from 'moment'
import {Modal} from 'react-bootstrap'
import {Modal as ModalVanilla} from 'bootstrap'

import '../../../../node_modules/react-big-calendar-scheduler/lib/css/react-big-calendar.css'
import '../../../../node_modules/react-datepicker/dist/react-datepicker.css'
import './HomePage.css'

import {toAbsoluteUrl} from '../../../_metronic/helpers'

import {EditorState} from 'draft-js'
import {stateFromHTML} from 'draft-js-import-html'
import {Editor} from 'react-draft-wysiwyg'
import {convertToHTML} from 'draft-convert'

import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
// Components
import VideoUploader from '../../components/VideoUploader'
import {ConceptoItem} from '../../components/ConceptoItem'

import Events from '../../resources/Events'
import {ServiciosItem} from '../../components/ServiciosItem'
import {VideoBanner} from '../../components/homepage/VideoBanner'
import {Promos} from '../../components/homepage/Promos'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import {BrandsItem} from '../../components/BrandsItem'

function HomePage() {
  const weekday = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
  const month = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]

  const [promos, setPromos] = useState('')
  const [conceptos, setConceptos] = useState('')
  const [servicios, setServicios] = useState('')
  const [brands, setBrands] = useState('')
  const [videoInfo, setVideoInfo] = useState('')
  const [events, setEvents] = useState('')
  const [modalEventImage, setModalEventImage] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState('')

  const [showNewPromo, setShowNewPromo] = useState(false)

  const handleCloseNewPromo = () => setShowNewPromo(false)
  const handleShowNewPromo = () => setShowNewPromo(true)

  const [showNewConcepto, setShowNewConcepto] = useState(false)

  const handleCloseNewConcepto = () => setShowNewConcepto(false)
  const handleShowNewConcepto = () => setShowNewConcepto(true)

  const [showDeletePromo, setShowDeletePromo] = useState(false)

  const handleCloseDeletePromo = () => setShowDeletePromo(false)
  const handleShowDeletePromo = (idElement) => {
    console.log(idElement)
    setShowDeletePromo(true)
    setDeletePromoId(idElement)
  }

  const [deleteConceptId, setDeleteConceptId] = useState('')
  const [showDeleteConcept, setShowDeleteConcept] = useState(false)
  const handleCloseDeleteConcept = () => setShowDeleteConcept(false)
  const handleShowDeleteConcept = (idElement) => {
    setShowDeleteConcept(true)
    setDeleteConceptId(idElement)
  }

  const [deleteBrandId, setDeleteBrandId] = useState('')
  const [showDeleteBrand, setShowDeleteBrand] = useState(false)
  const handleCloseDeleteBrand = () => setShowDeleteBrand(false)
  const handleShowDeleteBrand = (idElement) => {
    setShowDeleteBrand(true)
    setDeleteBrandId(idElement)
  }

  const [deletePromoId, setDeletePromoId] = useState('')
  const [checkColumnPromo, setCheckColumnPromo] = useState(false)

  const [showEvent, setShowEvent] = useState(false)
  const handleCloseEvent = () => setShowEvent(false)
  const handleShowEvent = () => {
    setShowEvent(true)
    console.log(document.getElementsByClassName('event-card')[0])
  }

  const [showNewEvent, setShowNewEvent] = useState(false)

  const handleCloseNewEvent = () => setShowNewEvent(false)
  const handleShowNewEvent = () => setShowNewEvent(true)

  const [showNewBrand, setShowNewBrand] = useState(false)

  const handleCloseNewBrand = () => setShowNewBrand(false)
  const handleShowNewBrand = () => setShowNewBrand(true)

  const [homeTextSection, setHomeTextSection] = useState('')
  const [editorRawHtml, setEditorRawHtml] = useState('')
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(stateFromHTML(editorRawHtml))
  )
  const [convertedContent, setConvertedContent] = useState(null)

  useEffect(() => {
    let html = convertToHTML(editorState.getCurrentContent())
    setConvertedContent(html)
  }, [editorState])

  useEffect(() => {
    getHomeTextSection()
    setEditorRawHtml()
  }, [editorRawHtml])

  const [color, setColor] = useState(
    'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(255,255,255,1) 100%)'
  )
  const {setSolid, setGradient} = useColorPicker(color, setColor)

  const url = 'https://puntosurgdl.com/backend/'

  const localizer = momentLocalizer(moment)

  function formatAMPM(date) {
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function (num) {
        return (num < 10 ? '0' : '') + num
      }

    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds()) +
      dif +
      pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' +
      pad(Math.abs(tzo) % 60)
    )
  }

  useEffect(() => {
    getGeneralElements()
    getEvents()
    getPromosData()
    getConceptData()
    getServicesData()
    getBrandsData()
  }, [])

  const saveHomeTextSection = () => {
    convertToHTML(editorState.getCurrentContent())
    const dataForm = {
      name: 'home-text-section',
      title: document.getElementById('home-text-section-title').value,
      description: convertedContent,
    }

    console.log(dataForm)

    axios
      .post(url + 'saveHomeTextSection.php', dataForm, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getHomeTextSection = () => {
    axios
      .get(url + 'getHomeTextSection.php')
      .then((response) => {
        console.log(response.data.data[0])
        setEditorRawHtml(response.data.data[0].description)
        setEditorState(() => EditorState.createWithContent(stateFromHTML(editorRawHtml)))
        setHomeTextSection(response.data.data[0])
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getGeneralElements = () => {
    axios
      .get(url + 'getGeneralElements.php')
      .then((response) => {
        let generalElements = response.data.data

        console.log(generalElements)

        let objColumn = generalElements.find((o) => o.idElement === 'column_active')
        setCheckColumnPromo(objColumn.content === 'true')
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getEvents = () => {
    axios
      .get(url + 'getEvents.php')
      .then((response) => {
        let events = response.data

        console.log('EVENTOS')
        console.log(response.data)
        setEvents(events)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const onChangeCheckColumn = (event) => {
    let columnIsActive = false

    if (event.target.checked) {
      console.log('is checked')
      columnIsActive = 1
    } else {
      console.log('is NOT checked')
      columnIsActive = 0
    }

    console.log(columnIsActive)

    const data = {
      name: 'column_active',
      content: columnIsActive,
    }

    axios
      .post(url + 'updateColumnIsActive.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          setCheckColumnPromo(columnIsActive)
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getPromosData = () => {
    axios
      .get(url + 'getPromosData.php')
      .then((response) => {
        let promos = response.data.data
        console.log(promos)
        //console.log(promos)
        setPromos(promos)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNewPromo = () => {
    const data = new FormData()

    if (document.getElementById('file-promociones-new').files.length !== 0) {
      for (let i = 0; i < document.getElementById('file-promociones-new').files.length; i++) {
        data.append('file[]', document.getElementById('file-promociones-new').files[i])
      }

      data.append('name', '')

      axios
        .post(url + 'uploadNewPromo.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            setPromos(res.data.data)
            handleCloseNewPromo()
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  const uploadNewConcepto = () => {
    const data = new FormData()

    if (document.getElementById('new-concept-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-concept-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-concept-img').files[i])
      }

      data.append('name', '')
      data.append('description', document.getElementById('new-concept-description').value)

      axios
        .post(url + 'uploadNewConcept.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            setConceptos(res.data.data)
            handleCloseNewConcepto()
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      alert('Seleccione una imagen')
    }
  }

  const uploadNewBrand = () => {
    const data = new FormData()

    if (document.getElementById('file-marcas-new').files.length !== 0) {
      for (let i = 0; i < document.getElementById('file-marcas-new').files.length; i++) {
        data.append('file[]', document.getElementById('file-marcas-new').files[i])
      }

      data.append('name', '')

      axios
        .post(url + 'uploadNewBrand.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            setBrands(res.data.data)
            handleCloseNewBrand()
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  const uploadNewEvent = () => {
    const data = new FormData()

    data.append('title', document.getElementById('new-event-title').value)
    data.append('start', toIsoString(startDate))
    if (endDate) {
      data.append('end', toIsoString(endDate))
    } else {
      data.append('end', '')
    }
    data.append('location', document.getElementById('new-event-location').value)
    data.append('category', document.getElementById('new-event-category').value)
    data.append('type', document.getElementById('new-event-type').value)
    if (document.getElementById('new-event-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-event-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-event-img').files[i])
      }
    }

    axios
      .post(url + 'uploadNewEvent.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setEvents(res.data)
          handleCloseNewEvent()
          // setPromos(res.data.data)
          // handleCloseNewPromo()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deletePromo = (idElement) => {
    console.log('delete promo')
    console.log(idElement)

    const data = {
      name: idElement,
    }

    axios
      .post(url + 'deletePromo.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setPromos(res.data.data)
          handleCloseDeletePromo()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deleteConcept = (idElement) => {
    const data = {
      name: idElement,
    }

    axios
      .post(url + 'deleteConcept.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setConceptos(res.data.data)
          handleCloseDeleteConcept()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deleteBrand = (idElement) => {
    const data = {
      name: idElement,
    }

    axios
      .post(url + 'deleteBrand.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setBrands(res.data.data)
          handleCloseDeleteBrand()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getConceptData = () => {
    axios
      .get(url + 'getConceptData.php')
      .then((response) => {
        // console.log(response)
        let conceptos = response.data.data
        setConceptos(conceptos)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getServicesData = () => {
    axios
      .get(url + 'getServicesData.php')
      .then((response) => {
        // console.log(response)
        let servicios = response.data.data
        setServicios(servicios)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getBrandsData = () => {
    axios
      .get(url + 'getBrandsData.php')
      .then((response) => {
        // console.log(response)
        let brands = response.data.data
        setBrands(brands)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const handleEventClick = ({event, el}) => {
    //myModal.toggle()
    var myModal = new ModalVanilla(document.getElementById('modalEvents'), {})
    myModal.toggle()

    let eventStartDate = new Date(event.start)

    let modalEvent = document.getElementById('modalEvents')
    modalEvent.getElementsByClassName(
      'modal-background'
    )[0].style.backgroundImage = `url(${event.extendedProps.imgUrl})`
    modalEvent.getElementsByClassName('modal-title')[0].innerHTML = event.title
    modalEvent.getElementsByClassName('fecha-evento')[0].innerHTML =
      weekday[eventStartDate.getDay()] +
      ' ' +
      eventStartDate.getDate() +
      ' de ' +
      month[eventStartDate.getMonth()]
    modalEvent.getElementsByClassName('hora-evento').innerHTML = formatAMPM(eventStartDate)
    modalEvent.getElementsByClassName('ubicacion-evento').innerHTML = event.extendedProps.location
    modalEvent.getElementsByClassName('tipo-evento').innerHTML = event.extendedProps.category
  }

  const submitColor = () => {
    const data = new FormData()

    data.append('name', 'home-video-color')
    data.append('element', color)

    axios.post('http://localhost/punto-sur-backend/updateElement.php', data, {}).then(
      (res) => {
        console.log(res)
      },
      (error) => {
        alert(error)
      }
    )
    // console.log(color)
  }

  const uploadFile = (idElement) => {
    console.log(idElement)

    const data = new FormData()

    for (let i = 0; i < document.getElementById('file-' + idElement).files.length; i++) {
      data.append('file[]', document.getElementById('file-' + idElement).files[i])
    }

    console.log(document.getElementById('file-' + idElement).files[0].name)
    console.log(document.getElementById('file-' + idElement).files.length)

    data.append('name', 'home-' + idElement)

    console.log(data)

    let url = 'http://localhost/punto-sur-backend/fileUpload.php'

    axios
      .post(url, data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data[0].url)
          document
            .getElementsByClassName('home-' + idElement)[0]
            .setAttribute('src', res.data[0].url)
        },
        (error) => {
          alert(error)
        }
      )
  }

  function previewImage(idElement) {
    const [file] = document.getElementById('file-' + idElement).files
    if (file) {
      document
        .getElementsByClassName('home-' + idElement)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-' + idElement).classList.remove('d-none')
    }
  }

  return (
    <div className='row g-5'>
      {/* VIDEO */}
      <VideoBanner videoInfo={videoInfo} />

      {/* <div className='col-lg-6'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Colores del degradado de video</h3>
          </div>
          <div className='card-body'>
            <ColorPicker
              value={color}
              onChange={setColor}
              hidePresets={false}
              hideControls={true}
            />
          </div>
          <div className='card-footer'>
            <button className='btn btn-primary float-end' onClick={() => submitColor()}>
              Guardar
            </button>
          </div>
        </div>
      </div> */}

      {/* PROMOCIONES */}

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carrusel de eventos</h3>
            <h5 className='card-subtitle'>
              Las imágenes deben tener una medida de 1920px por 800px y no pesar más de 1MB
            </h5>
            <div className='mt-n16 mb-10 float-end'>
              <button type='button' className='btn btn-primary' onClick={handleShowNewPromo}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <Promos promos={promos} deletePromo={handleShowDeletePromo} setPromos={setPromos} />
            </div>
          </div>
          <div className='card-footer d-none'>
            <div className='form-check form-switch form-check-custom form-check-solid d-none'>
              <input
                className='form-check-input'
                type='checkbox'
                value=''
                id='column-active'
                checked={checkColumnPromo}
                onChange={(e) => onChangeCheckColumn(e)}
              />
              <label className='form-check-label d-none' for='column-active'>
                Habilitar columna única
              </label>
            </div>
            <p className='ms-auto float-end'>
              Las imágenes deben tener una medida de 1920px por 800px y no pesar más de 1MB
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewPromo} onHide={handleCloseNewPromo}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar imagen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input
                id='file-promociones-new'
                type='file'
                className='form-control'
                accept='image/*'
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewPromo}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewPromo()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeletePromo} onHide={handleCloseDeletePromo}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar imagen promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar la imagen de promoción?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeletePromo}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deletePromo(deletePromoId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>

      {/* CALENDARIO */}
      <div className='col-lg-12 d-none'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Eventos, Talleres y Happenings</h3>
            <div className='mt-n20 mb-10 float-end'>
              <button type='button' className='btn btn-primary' onClick={handleShowNewEvent}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView='dayGridMonth'
              events={events}
              eventClick={handleEventClick}
            />
          </div>
        </div>
      </div>

      <div className='modal fade modal-events' tabIndex={-1} id='modalEvents'>
        <div className='modal-dialog'>
          <div className='modal-background'>
            <div className='modal-content item'>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-auto float-end'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <object
                  data='/admin/media/icons/duotune/arrows/arr061.svg'
                  type='image/svg+xml'
                ></object>
              </div>
              <div>
                <div>
                  <h2 class='modal-title'>ENCUENTRO INTERNACIONAL DEL MARIACHI Y LA CHARRERIA</h2>
                  <p class='fecha-evento'>Jueves 1 de Octubre</p>
                  <p class='hora-evento'>5:30 pm</p>
                  <p class='ubicacion-evento'>Salón Balcony</p>
                  <p class='tipo-evento'>Música regional</p>
                </div>
              </div>
              {/* <div className='modal-footer'>
              <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                Close
              </button>
              <button type='button' className='btn btn-primary'>
                Save changes
              </button>
            </div> */}
            </div>
          </div>
        </div>
      </div>

      <Modal show={showNewEvent} onHide={handleCloseNewEvent} className='modal-new-event'>
        <Modal.Header closeButton>
          <Modal.Title>Agregar evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Titulo:</label>
              <input type='text' className='form-control' id='new-event-title' />
            </div>
            <div className='form-group col-md-10'>
              <label>Fecha inicio:</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                timeInputLabel='Hora:'
                dateFormat='MM/dd/yyyy h:mm aa'
                showTimeInput
              />
            </div>
            <div className='form-group col-md-10'>
              <label>Fecha fin:</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                timeInputLabel='Hora:'
                dateFormat='MM/dd/yyyy h:mm aa'
                showTimeInput
              />
            </div>
            <div className='form-group col-md-10'>
              <label>Ubicación:</label>
              <select id='new-event-location' className='form-select'>
                <option value={`Mercado Sur`}>Mercado Sur</option>
                <option value={`Salon Balcony`}>Salon Balcony</option>
              </select>
            </div>
            <div className='form-group col-md-10'>
              <label>Categoría:</label>
              <input id='new-event-category' type='text' className='form-control' />
            </div>
            <div className='form-group col-md-10'>
              <label>Tipo:</label>
              <select id='new-event-type' className='form-select'>
                <option value={`happenings`}>Happenings</option>
                <option value={`talleres`}>Talleres</option>
              </select>
            </div>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='new-event-img' type='file' className='form-control' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewEvent}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={uploadNewEvent}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      {/* <Modal
        className='modal-events'
        show={showEvent}
        onHide={handleCloseEvent}
        backdrop={false}
        contentClassName='event-card'
      >
        <Modal.Header closeButton>
          <Modal.Title>ENCUENTRO INTERNACIONAL DEL MARIACHI Y LA CHARRERIA</Modal.Title>
        </Modal.Header>
        <div className='item'>
          <p class='fecha-evento'>Jueves 1 de Octubre</p>
          <p class='hora-evento'>5:30 pm</p>
          <p class='ubicacion-evento'>Salón Balcony</p>
          <p class='tipo-evento'>Música regional</p>
        </div>
      </Modal> */}

      {/* SECCION DE TEXTO */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Sección texto</h3>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Titulo:</label>
                <input
                  type='text'
                  className='form-control'
                  id='home-text-section-title'
                  defaultValue={homeTextSection.title}
                />
              </div>
            </div>
            <div className='form-group col-md-12'>
              <label>Contenido:</label>
              <Editor
                editorState={editorState}
                toolbarClassName='toolbarClassName'
                wrapperClassName='wrapperClassName'
                onEditorStateChange={setEditorState}
              />
            </div>
          </div>
          <div className='card-footer'>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-6'
                onClick={() => saveHomeTextSection()}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* CONCEPTOS */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carrusel de Concepto</h3>
            <h5 className='card-subtitle'>
              Las imágenes deben tener una medida de 1920px por 800px y no pesar más de 1MB
            </h5>
            <div className='float-end mt-n16'>
              <button className='btn btn-primary' onClick={handleShowNewConcepto}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row' id='carousel-concepto'>
              <ConceptoItem conceptos={conceptos} deleteConcept={handleShowDeleteConcept} />
            </div>
          </div>
          <div className='card-footer d-none'>
            <p className='ms-auto float-end'>
              Las imágenes deben tener una medida de 1920px por 100px y no pesar más de 1MB
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewConcepto} onHide={handleCloseNewConcepto}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Concepto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Frase:</label>
              <input type='text' className='form-control' id='new-concept-description' />
            </div>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='new-concept-img' type='file' className='form-control' accept='image/*' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewConcepto}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewConcepto()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteConcept} onHide={handleCloseDeleteConcept}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Concepto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar el concepto?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteConcept}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteConcept(deleteConceptId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>

      {/* SERVICIOS */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carrusel de servicios</h3>
            <h5 className='card-subtitle'>
              Las imágenes deben tener un formato vertical, con una medida mínima de 300px por
              460px, o proporcional. Y no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <ServiciosItem servicios={servicios} />
              {/* <div className='col-lg-2'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0 ribbon'>
                    <div id='ribbon-servicios-1' className='ribbon-label bg-danger'>
                      Sin guardar
                    </div>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-1.jpg')}
                        alt=''
                        className='w-100 rounded home-servicios-1'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-servicios-1'
                          name='file-servicios-1'
                          className='input-image'
                          onChange={() => uploadFile('servicios-1')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-servicios-1').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <label className='form-label'>Titulo</label>
                <input
                  id='titulo-servicios-1'
                  name='titulo-servicios-1'
                  className='form-control'
                  type='text'
                />
                <label className='form-label'>Link</label>
                <input
                  id='descripcion-servicios-1'
                  name='descripcion-servicios-1'
                  className='form-control'
                  type='text'
                />
                <div className='mt-4'>
                  <button className='btn btn-primary btn-sm'>Guardar</button>
                  <button className='btn btn-danger float-end btn-sm'>Eliminar</button>
                </div>
              </div>

              <div className='col-lg-2'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-2.jpg')}
                        alt=''
                        className='w-100 rounded home-servicios-2'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-servicios-2'
                          name='file-servicios-2'
                          className='input-image'
                          onChange={() => uploadFile('servicios-2')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-servicios-2').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-2'>
                <div className='card card-custom overlay overflow-hidden mb-8'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-3.jpg')}
                        alt=''
                        className='w-100 rounded home-servicios-3'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-servicios-3'
                          name='file-servicios-3'
                          className='input-image'
                          onChange={() => uploadFile('servicios-3')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-servicios-3').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-2'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-4.jpg')}
                        alt=''
                        className='w-100 rounded home-servicios-4'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-servicios-4'
                          name='file-servicios-4'
                          className='input-image'
                          onChange={() => uploadFile('servicios-4')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-servicios-4').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-2'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-5.jpg')}
                        alt=''
                        className='w-100 rounded home-servicios-5'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-servicios-5'
                          name='file-servicios-5'
                          className='input-image'
                          onChange={() => uploadFile('servicios-5')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-servicios-5').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-2'>
                <div className='card card-custom overlay overflow-hidden'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-6.jpg')}
                        alt=''
                        className='w-100 rounded home-servicios-6'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-6'>
                        <input
                          type='file'
                          id='file-servicios-6'
                          name='file-servicios-6'
                          className='input-image'
                          onChange={() => uploadFile('servicios-6')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-servicios-6').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className='card-footer d-none'>
            {/* <button className='btn btn-primary float-end'>Guardar</button> */}
            <p className='ms-auto float-end'>
              Las imágenes deben tener un formato vertical, con una medida mínima de 300px por
              460px, o proporcional. Y no pesar más de 1MB
            </p>
          </div>
        </div>
      </div>

      {/* MARCAS */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carrusel de Marcas</h3>
            <h5 className='card-subtitle'>
              Las imágenes de los logos deben subirse en formato .png y una medida de 400px por
              130px de alto. Revisar la proporción de tamaño.
            </h5>
            <div className='float-end mt-n16'>
              <button className='btn btn-primary' onClick={handleShowNewBrand}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <BrandsItem
                brands={brands}
                setBrands={setBrands}
                deleteBrand={handleShowDeleteBrand}
              />
              {/* <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-1.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-1'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-marcas-1'
                          name='file-marcas-1'
                          className='input-image'
                          onChange={() => uploadFile('marcas-1')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-1').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-2.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-2'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-marcas-2'
                          name='file-marcas-2'
                          className='input-image'
                          onChange={() => uploadFile('marcas-2')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-2').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden mb-8 card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-3.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-3'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-marcas-3'
                          name='file-marcas-3'
                          className='input-image'
                          onChange={() => uploadFile('marcas-3')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-3').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-4.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-4'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-marcas-4'
                          name='file-marcas-4'
                          className='input-image'
                          onChange={() => uploadFile('marcas-4')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-4').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-5.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-5'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-5'>
                        <input
                          type='file'
                          id='file-marcas-5'
                          name='file-marcas-5'
                          className='input-image'
                          onChange={() => uploadFile('marcas-5')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-5').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-6.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-6'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-6'>
                        <input
                          type='file'
                          id='file-marcas-6'
                          name='file-marcas-6'
                          className='input-image'
                          onChange={() => uploadFile('marcas-6')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-6').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-7.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-7'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-6'>
                        <input
                          type='file'
                          id='file-marcas-7'
                          name='file-marcas-7'
                          className='input-image'
                          onChange={() => uploadFile('marcas-7')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-7').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='card card-custom overlay overflow-hidden card-marcas'>
                  <div className='card-body p-0'>
                    <div className='overlay-wrapper'>
                      <img
                        src={toAbsoluteUrl('/media/stock/600x400/img-8.jpg')}
                        alt=''
                        className='w-100 rounded home-marcas-8'
                      />
                    </div>
                    <div className='overlay-layer bg-dark bg-opacity-10'>
                      <div className='d-flex flex-grow-1 flex-center py-6'>
                        <input
                          type='file'
                          id='file-marcas-8'
                          name='file-marcas-8'
                          className='input-image'
                          onChange={() => uploadFile('marcas-8')}
                        />
                        <input
                          id='button'
                          type='button'
                          value='Cambiar...'
                          className='btn btn-light-primary'
                          onClick={() => document.getElementById('file-marcas-8').click()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div className='card-footer d-none'>
            {/* <button className='btn btn-primary float-end'>Guardar</button> */}
            <p className='ms-auto float-end'>
              Las imágenes de los logos deben subirse en formato .png
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewBrand} onHide={handleCloseNewBrand}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar imagen marca</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='file-marcas-new' type='file' className='form-control' accept='.png' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewBrand}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewBrand()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteBrand} onHide={handleCloseDeleteBrand}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar imagen promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar la imagen de promoción?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteBrand}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteBrand(deleteBrandId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>

      {/* END MAIN ROW */}
    </div>
  )
}

export {HomePage}
